import React, { useEffect, useState } from "react";
import { Table, Thead, Tr, Th, Tbody, Td } from "@locus-taxy/neo-ui";
import { Button, Result, Spin, Pagination, Tag, Input } from "antd";
import {
  CaretDownOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import AssignGroupModal from "./AssignGroupModal";
import { updateLoader } from "../../redux/action/loaderAction";
import { teamsFetch } from "../../redux/action/teamActions";
import {
  useCreateTeamGroupMappingMutation,
  useUpdateTeamGroupMappingMutation,
} from "../../app/services/lily";
import { defaultGroup } from "../../helpers/constant";

export const TeamGroupMapping = ({ openNotificationWithIcon }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const teams = useSelector((state) => state?.team?.all);
  const [total, setTotal] = useState(0);
  const [currentTeamVisible, setCurrentTeamVisible] = useState([]);
  const [allTeams, setAllTeams] = useState([]);

  const [isRefresh, setIsRefresh] = useState(true);

  const isLoading = useSelector((state) => state?.loader?.genericLoading);

  const { clientId, authToken } = queryString.parse(location.search);

  const [selectedRows, setSelectedRows] = useState([]);
  const [visible, setVisible] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);

  const getRandomColor = () => {
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
  };

  const [
    updateTeamGroupMapping,
    {
      isLoading: isUpdating,
      data: updateTeamGroupMappingData,
      error: updateTeamGroupMappingError,
      isError: isUpdateTeamGroupMappingError,
      isSuccess: isUpdateTeamGroupMappingSuccess,
    },
  ] = useUpdateTeamGroupMappingMutation();

  const [
    createTeamGroupMapping,
    {
      isLoading: isCreating,
      data: createTeamGroupMappingData,
      error: createTeamGroupMappingError,
      isError: iscreateTeamGroupMappingError,
      isSuccess: iscreateTeamGroupMappingSuccess,
    },
  ] = useCreateTeamGroupMappingMutation();

  const handleAssignGroup = (data) => {
    if (selectedRows) {
      updateTeamGroupMapping({
        clientId,
        authToken,
        reqBody: data,
        id: selectedRows?.[0]?.id,
      });
    } else {
      createTeamGroupMapping({ clientId, authToken, reqBody: data });
    }
  };

  useEffect(
    () => {
      if (iscreateTeamGroupMappingSuccess || isUpdateTeamGroupMappingSuccess) {
        setVisible(false);
        setIsRefresh(true);
        openNotificationWithIcon(
          "success",
          "Group Updated Successfully",
          JSON.stringify(
            createTeamGroupMappingData?.message ||
              updateTeamGroupMappingData?.message ||
              "Group Updated Successfully"
          )
        );
      }
    }, //eslint-disable-next-line
    [iscreateTeamGroupMappingSuccess, isUpdateTeamGroupMappingSuccess]
  );

  useEffect(
    () => {
      if (!iscreateTeamGroupMappingError && !isUpdateTeamGroupMappingError)
        return;

      if (
        createTeamGroupMappingError?.status === 401 ||
        updateTeamGroupMappingError?.status === 401
      )
        navigate("/unauthorized");
      handleError([
        createTeamGroupMappingError?.data?.data?.message ||
          createTeamGroupMappingError?.data?.message ||
          updateTeamGroupMappingError?.data?.message ||
          updateTeamGroupMappingError?.data?.data?.message,
      ]);
    }, //eslint-disable-next-line
    [
      iscreateTeamGroupMappingError,
      createTeamGroupMappingError,
      navigate,
      location,
      isUpdateTeamGroupMappingError,
      updateTeamGroupMappingError,
    ]
  );

  useEffect(
    () => {
      if (isRefresh) {
        dispatch(updateLoader({ reconLoading: true }));
        dispatch(teamsFetch({ clientId, authToken }, navigate, handleError));
        setIsRefresh(false);
      }
    }, //eslint-disable-next-line
    [authToken, clientId, dispatch, isRefresh]
  );

  useEffect(() => {
    setAllTeams(teams);
  }, [teams]);

  useEffect(
    () => {
      setTotal(allTeams.length);
      setPage(1);
      setCurrentTeamVisible(allTeams.slice(0, pageSize));
    }, //eslint-disable-next-line
    [pageSize, allTeams]
  );

  useEffect(
    () => {
      const startIndex = (page - 1) * pageSize;
      setCurrentTeamVisible(allTeams.slice(startIndex, startIndex + pageSize));
    }, //eslint-disable-next-line
    [page]
  );

  const handleError = (error) => {
    dispatch(updateLoader({ reconLoading: false }));
    openNotificationWithIcon(
      "error",
      "Something went wrong",
      JSON.stringify(
        error?.message || error?.errorResponse?.errorMessage || error
      )
    );
  };

  const handleAction = (id = null) => {
    if (id) {
      const groupDetails = currentTeamVisible.find((team) => team?.id === id);
      setSelectedRows([groupDetails]);
    }
    setVisible(true);
  };

  const renderActionButton = (record = null) => {
    return (
      <div>
        <Button
          onClick={() => handleAction(record?.id)}
          style={{
            color: "rgb(0, 114, 245)",
            marginRight: "5px",
            border: "none",
          }}
          icon={<EditOutlined />}
        >
          Assign Group
        </Button>
      </div>
    );
  };

  return (
    <>
      <AssignGroupModal
        visible={visible}
        setVisible={setVisible}
        selectedRows={selectedRows}
        handleAssignGroup={handleAssignGroup}
      />
      {isLoading || isCreating || isUpdating ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" />
        </div>
      ) : currentTeamVisible.length > -1 ? (
        <div>
          <h2 style={{ marginBottom: "1px" }}>Assigning Groups</h2>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "2px",
            }}
          >
            <div>
              <p>Total: {total} teams</p>
            </div>
          </div>
          <div style={{ height: "80vh", overflowY: "auto", overflowX: "auto" }}>
            <Table>
              <Thead>
                <Tr>
                  <Th key="name">
                    <div style={{ marginTop: "5px" }}>
                      <Input
                        placeholder="Team Name"
                        style={{ width: "80%", borderRadius: "4px" }}
                        prefix={<SearchOutlined style={{ color: "#1890ff" }} />}
                        onChange={(e) =>
                          setAllTeams(
                            teams.filter((t) => t?.id?.includes(e.target.value))
                          )
                        }
                        suffix={<CaretDownOutlined />}
                      />
                    </div>
                  </Th>
                  <Th key="group">Group Assigned</Th>
                  <Th key="action">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentTeamVisible.map((record, index) => (
                  <Tr key={index}>
                    <Td>
                      <Tag
                        style={{
                          borderLeft: `${"2px solid " + getRandomColor()}`,
                          backgroundColor: "#E7E9EE",
                        }}
                      >
                        {record?.id}
                      </Tag>
                    </Td>
                    <Td>
                      {record?.customProperties?.groupName ||
                        `${defaultGroup.groupName} (default)`}
                    </Td>
                    <Td>{renderActionButton(record)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <Pagination
              defaultCurrent={page}
              total={total}
              size="small"
              onChange={(page, _pageSize) => {
                setPage(page);
              }}
              pageSize={pageSize}
              pageSizeOptions={[25, 50, 100]}
              onShowSizeChange={(_current, size) => {
                setPageSize(size);
              }}
              showSizeChanger
            />
          </div>
        </div>
      ) : (
        <Result
          status="warning"
          title="No Teams Found"
          subTitle="No Groups-Teams Found."
        />
      )}
    </>
  );
};
